import ScrollRevealer from './ScrollRevealer';

export default ScrollRevealer;
